import { combineReducers } from "@reduxjs/toolkit";

import { fabricAppPerksListingReducer } from "./FabricAppPerksListingSlice";

export const perksReducer = combineReducers({
  fabricAppPerksListing: fabricAppPerksListingReducer,
});
